/**
 * Carbon Gallery Patch（适配 Ella 7.2.0 官方版）
 *
 * 前置条件（主题编辑器中）：
 *   1. Theme settings → Variant pills → "Show variant media grouped" 必须开启
 *      （开启后主题会给图片和色板加颜色映射 class，patch 才能知道哪张图属于哪个颜色；
 *       patch 已覆盖其过滤/重建行为，所以不会隐藏/重排图片）
 *   2. blocks/_product-media-gallery.liquid 已做最小改动：sorted_media 直接使用
 *      selected_product.media，禁止服务端把当前变体首图置顶（保持媒体原始顺序）
 *   3. 每张产品图片的 alt 文本需包含对应的颜色关键词（不要求精确等于色板值，
 *      只要 alt 里包含色板值对应的 handle 子串即可）
 *
 * 效果：
 *   - 图片按色板顺序分组重排（同色内保持后台上传原序，未匹配颜色的图放最前）
 *   - 进详情页时不管 URL 是否带 ?variant= 参数，始终按首图颜色自动选中色板，
 *     确保列表页主图与详情页首屏一致（URL 中的 variant 不匹配首图时会被清除）
 *   - 点击颜色直接跳转到该颜色第一张图（无滑动动画）
 *   - 不隐藏其他颜色图片，所有颜色图片始终可见
 *   - zoom 弹窗缩略图也按色板顺序重排
 */
(function () {
  if (window.__carbonGalleryPatchApplied) return;
  window.__carbonGalleryPatchApplied = true;

  // 初始化静默期标志：autoSelectFirstImageColor 触发 change → fetch 期间为 true，
  // 让 updateMedia 的 setActiveMedia 和 _onVariantChange 都用 smooth=false 避免闪烁
  var _silentNav = false;
  var _syncingSwatches = false;

  function toHandle(str) {
    if (!str) return '';
    return String(str)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function findFirstMatchingSlide(gallery, inputEl) {
    if (!gallery || !inputEl) return null;

    const dataFilter = inputEl.getAttribute && inputEl.getAttribute('data-filter');
    const variantGrouped = inputEl.getAttribute && inputEl.getAttribute('data-variant-image-grouped');
    const rawVal = (inputEl.value || '').trim();

    const preciseKeywords = [];
    if (dataFilter) {
      const cls = dataFilter.trim().replace(/^\./, '');
      if (cls) preciseKeywords.push(cls);
    }
    if (variantGrouped) {
      variantGrouped.split(',').map(function (s) { return s.trim(); }).filter(Boolean).forEach(function (k) {
        const h = 'filter-' + toHandle(k);
        if (preciseKeywords.indexOf(h) === -1) preciseKeywords.push(h);
      });
    }
    if (rawVal) {
      const h = 'filter-' + toHandle(rawVal);
      if (preciseKeywords.indexOf(h) === -1) preciseKeywords.push(h);
    }

    const preciseHandles = preciseKeywords.map(function (kw) {
      return kw.replace(/^filter-/, '');
    }).filter(Boolean);

    const fallbackWords = [];
    if (rawVal) {
      rawVal.toLowerCase().split(/\s+/).filter(function (w) {
        return w.length > 2 && !/^(the|and|with|dress|gown|lace|flower|girls?|mini|a-line|for|from|satin|tulle|pearl|waist|sleeveless|bow|ball|puffy|applique|high-low|v-neck|line)$/i.test(w);
      }).forEach(function (w) {
        const h = 'filter-' + toHandle(w);
        if (preciseKeywords.indexOf(h) === -1 && fallbackWords.indexOf(h) === -1) fallbackWords.push(h);
      });
    }

    var swiperComponent = gallery.querySelector('swiper-component');
    var mainWrapper = swiperComponent ? swiperComponent.querySelector('.swiper-wrapper') : null;
    var slides;
    if (mainWrapper) {
      slides = mainWrapper.querySelectorAll('.swiper-slide');
    } else {
      slides = gallery.querySelectorAll('.swiper-slide');
    }

    for (let i = 0; i < slides.length; i++) {
      for (let k = 0; k < preciseKeywords.length; k++) {
        if (slides[i].classList && slides[i].classList.contains(preciseKeywords[k])) {
          return { slide: slides[i], index: i };
        }
      }
    }

    for (let i = 0; i < slides.length; i++) {
      const cls = ' ' + (slides[i].className || '') + ' ';
      for (let k = 0; k < preciseHandles.length; k++) {
        const handle = preciseHandles[k];
        if (!handle) continue;
        const escaped = handle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const re = new RegExp('(^|\\s|-)' + escaped + '(\\s|-|$)');
        if (re.test(cls)) {
          return { slide: slides[i], index: i };
        }
      }
    }

    for (let i = 0; i < slides.length; i++) {
      const cls = ' ' + (slides[i].className || '') + ' ';
      for (let k = 0; k < fallbackWords.length; k++) {
        const cleanKw = fallbackWords[k].replace(/^filter-/, '');
        if (!cleanKw) continue;
        const escaped = cleanKw.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const re = new RegExp('(^|\\s|-)' + escaped + '(\\s|-|$)');
        if (re.test(cls)) {
          return { slide: slides[i], index: i };
        }
      }
    }

    return null;
  }

  function findCheckedColor() {
    const checkedRadios = document.querySelectorAll('input[type="radio"][data-filter]:checked');
    for (let i = 0; i < checkedRadios.length; i++) {
      const input = checkedRadios[i];
      if (input.disabled || input.classList.contains('disabled')) continue;
      const filter = input.getAttribute('data-filter');
      if (filter) return filter.replace(/^\./, '');
    }
    return null;
  }

  function navigateToActiveColor(instance, inputEl, smooth) {
    if (!inputEl) return;
    try {
      var gallery = instance && instance._getGallery ? instance._getGallery() : document.querySelector('media-gallery');
      if (!gallery) return;

      var targetFilter = inputEl.getAttribute && inputEl.getAttribute('data-filter');
      if (!targetFilter) return;

      function attemptSlide(retries) {
        try {
          var sc = gallery.querySelector('swiper-component');
          if (!sc) {
            if (retries > 0) setTimeout(function() { attemptSlide(retries - 1); }, 80);
            return;
          }
          if (!sc.initSwiper) {
            if (retries > 0) {
              setTimeout(function() { attemptSlide(retries - 1); }, 80);
            } else {
              return;
            }
            return;
          }
          var mainSwiper = sc.initSwiper;

          var match = findFirstMatchingSlide(gallery, inputEl);
          if (!match) return;

          var speed = smooth ? 800 : 0;
          _lastTargetIndex = match.index;
          mainSwiper.slideTo(match.index, speed);

          syncSwatchVisualState(inputEl);

          if (!smooth) {
            requestAnimationFrame(function() {
              requestAnimationFrame(function() {
                try { mainSwiper.update(); } catch (e) {}
              });
            });
            setTimeout(function() {
              try {
                mainSwiper.update();
                var ts = gallery.querySelector('.swiper-controls__thumbnails-container .swiper');
                var thumbsSwiper = ts && ts.swiper;
                if (thumbsSwiper) {
                  var perView = thumbsSwiper.params.slidesPerView;
                  var total = thumbsSwiper.slides.length;
                  var tv = perView === 'auto'
                    ? (thumbsSwiper.slides.filter(function(s) { return s.classList.contains('swiper-slide-visible'); }).length || 1)
                    : perView;
                  var target = match.index - Math.floor(tv / 2);
                  if (target < 0) target = 0;
                  if (target > total - tv) target = total - tv;
                  thumbsSwiper.slideTo(target, 0);
                }
              } catch (e) {}
            }, 50);
          }
        } catch (e) {
          if (retries > 0) setTimeout(function() { attemptSlide(retries - 1); }, 80);
        }
      }
      attemptSlide(15);
    } catch (e) { /* silent */ }
  }

  // 记录用户最后选择的颜色filter（用于DOM替换后恢复）
  var _lastSelectedFilter = null;
  var _lastTargetIndex = null;
  var _guardActive = false;
  var _guardFrameCount = 0;
  var _swipersPatched = new WeakSet();

  function getCurrentGallery() {
    return document.querySelector('media-gallery');
  }

  function getCurrentSwiper() {
    var gallery = getCurrentGallery();
    var sc = gallery && gallery.querySelector('swiper-component');
    return sc && sc.initSwiper ? sc.initSwiper : null;
  }

  function patchSwiperInterceptor(swiper) {
    if (!swiper || _swipersPatched.has(swiper)) return;
    _swipersPatched.add(swiper);
    var origSlideTo = swiper.slideTo.bind(swiper);
    swiper.slideTo = function(index, speed) {
      if (_guardActive && _lastTargetIndex !== null && index !== _lastTargetIndex) {
        return origSlideTo(_lastTargetIndex, 0);
      }
      return origSlideTo(index, speed);
    };
  }

  function patchAllSwipers() {
    var swiper = getCurrentSwiper();
    if (swiper) patchSwiperInterceptor(swiper);
  }

  function findMatchingInputForFilter(filter) {
    if (!filter) return null;
    var allInputs = document.querySelectorAll('input[type="radio"][data-filter]');
    for (var i = 0; i < allInputs.length; i++) {
      if (allInputs[i].getAttribute('data-filter') === filter
          && !allInputs[i].disabled && !allInputs[i].classList.contains('disabled')) {
        return allInputs[i];
      }
    }
    return null;
  }

  function syncSwatchVisualState(targetInput) {
    if (!targetInput) return;
    var targetFilter = targetInput.getAttribute('data-filter');
    var allSwatches = document.querySelectorAll('.swatch-item');
    for (var i = 0; i < allSwatches.length; i++) {
      var sw = allSwatches[i];
      var span = sw.querySelector('[data-variant-id], [data-title]');
      var swatchFilter = span ? span.getAttribute('data-title')?.trim() : null;
      var parent = sw.closest('label, [data-filter-color]');
      var input = parent ? parent.querySelector('input[type="radio"][data-filter]') : null;
      var swFilter = input ? input.getAttribute('data-filter') : swatchFilter;
      if (swFilter === targetFilter) {
        sw.classList.add('active');
      } else {
        sw.classList.remove('active');
      }
    }
  }

  function forceRestoreSelection() {
    if (!_lastSelectedFilter) return false;

    patchExistingMediaGalleries();
    patchAllSwipers();

    var targetInput = findMatchingInputForFilter(_lastSelectedFilter);
    if (!targetInput) return false;

    var needsFix = false;

    var checked = document.querySelectorAll('input[type="radio"][data-filter]:checked');
    for (var i = 0; i < checked.length; i++) {
      if (checked[i].getAttribute('data-filter') !== _lastSelectedFilter) {
        checked[i].checked = false;
        needsFix = true;
      }
    }

    if (!targetInput.checked) {
      targetInput.checked = true;
      needsFix = true;
    }

    syncSwatchVisualState(targetInput);

    var swiper = getCurrentSwiper();
    if (swiper && swiper.slides) {
      var gallery = getCurrentGallery();
      var match = findFirstMatchingSlide(gallery, targetInput);
      if (match) {
        _lastTargetIndex = match.index;
        if (swiper.activeIndex !== match.index) {
          swiper.slideTo(match.index, 0);
          needsFix = true;
        }
      }
    }
    return needsFix;
  }

  function guardLoop() {
    if (!_guardActive) return;
    _guardFrameCount++;
    forceRestoreSelection();
    if (_guardFrameCount >= 240) {
      _guardActive = false;
      return;
    }
    requestAnimationFrame(guardLoop);
  }

  function startGuard() {
    _guardActive = true;
    _guardFrameCount = 0;
    patchAllSwipers();
    requestAnimationFrame(guardLoop);
    setTimeout(function() { _guardActive = false; }, 4000);
  }

  function stopGuard() {
    _guardActive = false;
  }

  function patchPrototype(proto) {
    if (!proto || proto.__carbonPatched) return;
    proto.__carbonPatched = true;

    const origOnInputChange = proto._onInputChange;

    function syncColorSwatches(targetInput) {
      if (!targetInput || _syncingSwatches) return;
      const targetFilter = targetInput.getAttribute('data-filter');
      if (!targetFilter) return;

      _syncingSwatches = true;
      try {
        // 只同步视觉状态（active class），不操作 radio 的 checked 状态。
        // radio 状态由 stickyATC.syncStickyToMain / syncMainToSticky 负责双向同步，
        // 手动操作 radio.checked 会导致级联 change 事件中断正在进行的 fetch。
        syncSwatchVisualState(targetInput);
      } finally {
        setTimeout(function () { _syncingSwatches = false; }, 0);
      }
    }

    proto._applyFilterFromInput = function (inputEl) {
      navigateToActiveColor(this, inputEl, false);
    };
    proto._applyFilterFromInputGrid = function (inputEl) {
      navigateToActiveColor(this, inputEl, false);
    };
    proto._onInputChange = function (event) {
      if (_syncingSwatches) return;
      if (origOnInputChange) {
        origOnInputChange.call(this, event);
      }
      const target = event.target;
      if (target.type === 'radio' && !target.checked) return;

      _lastSelectedFilter = target.getAttribute('data-filter');
      syncColorSwatches(target);

      _silentNav = true;
      navigateToActiveColor(this, target, false);

      startGuard();

      var cleared = false;
      function clearSilent() {
        if (cleared) return;
        cleared = true;
        _silentNav = false;
      }
      setTimeout(clearSilent, 8000);
    };
    proto._onVariantChange = function () {
      if (_silentNav) return;
      const activeColor = findCheckedColor();
      if (!activeColor) return;
      
      const targetFilter = '.' + activeColor;
      const allInputs = document.querySelectorAll('input[type="radio"][data-filter]');
      for (let i = 0; i < allInputs.length; i++) {
        if (allInputs[i].getAttribute('data-filter') === targetFilter && allInputs[i].checked) {
          navigateToActiveColor(this, allInputs[i], false);
          return;
        }
      }
    };
    proto._applyZoomDialogFilters = function () {};
    proto._resetZoomDialogFilters = function () {};
    proto._applyVideoDialogFilters = function () {};
    proto._resetVideoDialogFilters = function () {};
    proto._resetFilters = function () {};
    proto._rebuildGalleryWithFilters = function () { return false; };
  }

  // === 色板顺序读取 ===
  // 从所有 variant-media-grouped 实例的 input/option 收集色板顺序（data-filter）
  // 只收集启用了 data-filter 的（即颜色选项），顺序遵循后台产品里颜色 option 的 values 顺序
  function getColorOrder() {
    const instances = document.querySelectorAll('[is="variant-media-grouped"]');
    const colors = [];
    instances.forEach(function (instance) {
      const inputs = instance.querySelectorAll('input[type="radio"][data-filter], option[data-filter]');
      Array.prototype.forEach.call(inputs, function (input) {
        const dataFilter = input.getAttribute('data-filter');
        if (!dataFilter) return;
        const cls = dataFilter.trim().replace(/^\./, '');
        if (cls && colors.indexOf(cls) === -1) colors.push(cls);
      });
    });
    return colors;
  }

  // 判断元素属于哪个颜色（返回 colorOrder 中的索引，-1 表示未匹配）
  function getSlideColorIndex(el, colorOrder) {
    if (!el || !colorOrder || !colorOrder.length) return -1;
    const colorClass = getSlideColorClass(el, colorOrder);
    if (colorClass) return colorOrder.indexOf(colorClass);
    return -1;
  }

  // 重排容器子节点：未匹配图放最前，匹配图按 colorOrder 顺序，同色内保持原序
  // 若 prioritizeColor 指定了颜色，该颜色组排最前（其余仍按 colorOrder），用于进详情页时
  // 让首屏直接显示首图颜色，避免 Swiper 初始化后再滑动的闪烁
  function reorderContainer(container, colorOrder, prioritizeColor) {
    if (!container || !colorOrder || !colorOrder.length) return false;
    const children = Array.prototype.slice.call(container.children);
    if (children.length <= 1) return false;

    const unmatched = [];
    const groups = {};
    colorOrder.forEach(function (c) { groups[c] = []; });
    let hasMatched = false;

    children.forEach(function (child) {
      const idx = getSlideColorIndex(child, colorOrder);
      if (idx === -1) {
        unmatched.push(child);
      } else {
        groups[colorOrder[idx]].push(child);
        hasMatched = true;
      }
    });

    if (!hasMatched) return false;

    var newOrder = [];
    // 优先颜色组排最前（确保Swiper初始化第0张就是选中颜色）
    if (prioritizeColor && groups[prioritizeColor] && groups[prioritizeColor].length) {
      newOrder.push.apply(newOrder, groups[prioritizeColor]);
    }
    // 未匹配颜色的图片紧随其后（额外颜色/下架颜色的图）
    newOrder.push.apply(newOrder, unmatched);
    // 其余颜色按色板顺序排列
    colorOrder.forEach(function (c) {
      if (prioritizeColor && c === prioritizeColor) return;
      if (groups[c] && groups[c].length) {
        newOrder.push.apply(newOrder, groups[c]);
      }
    });

    let changed = false;
    for (let i = 0; i < newOrder.length; i++) {
      if (newOrder[i] !== children[i]) { changed = true; break; }
    }
    if (!changed) return false;

    while (container.firstChild) container.removeChild(container.firstChild);
    newOrder.forEach(function (child) { container.appendChild(child); });
    return true;
  }

  // destroy swiper 实例并重置初始化标记，便于 re-init
  function destroyAndResetSwiper(swiperComponent) {
    if (!swiperComponent) return;
    if (swiperComponent.initSwiper) {
      try { swiperComponent.initSwiper.destroy(true, true); } catch (e) {}
      swiperComponent.initSwiper = null;
    }
    if (swiperComponent._thumbsSwiper) {
      try { swiperComponent._thumbsSwiper.destroy(true, true); } catch (e) {}
      swiperComponent._thumbsSwiper = null;
    }
    if (swiperComponent.swiperEl) {
      swiperComponent.swiperEl._swiperInitialized = false;
    }
    if (swiperComponent._thumbnailSwiper) {
      swiperComponent._thumbnailSwiper._swiperInitialized = false;
    }
  }

  // 重排页面上所有图集（主 swiper / 缩略图 / zoom 弹窗）
  // prioritizeColor: 指定优先排最前的颜色 class（如 filter-dusty-blue），用于首屏无闪烁
  function reorderAllGalleries(colorOrder, prioritizeColor) {
    if (!colorOrder || !colorOrder.length) return;
    const galleries = document.querySelectorAll('media-gallery');
    galleries.forEach(function (gallery) {
      const swiperComponent = gallery.querySelector('swiper-component');
      const mainWrapper = swiperComponent && swiperComponent.querySelector('.swiper-wrapper');
      const thumbsWrapper = gallery.querySelector('.swiper-controls__thumbnails-container .swiper-wrapper');
      const zoomThumbsList = gallery.querySelector('.dialog-thumbnails-list');

      const swiperWasInited = !!(swiperComponent && swiperComponent.initSwiper);
      if (swiperWasInited) destroyAndResetSwiper(swiperComponent);

      let changed = false;
      if (mainWrapper && reorderContainer(mainWrapper, colorOrder, prioritizeColor)) changed = true;
      if (thumbsWrapper && thumbsWrapper !== mainWrapper && reorderContainer(thumbsWrapper, colorOrder, prioritizeColor)) changed = true;
      if (zoomThumbsList && reorderContainer(zoomThumbsList, colorOrder, prioritizeColor)) changed = true;

      if (changed && swiperComponent && swiperComponent.initializeSwiper) {
        swiperComponent.initializeSwiper();
      }
    });
  }

  // 判断 slide 属于哪个颜色 class（完整 handle），返回 colorOrder 中的完整 class 名
  // 使用与 findFirstMatchingMediaId 相同的精确匹配策略，避免 dusty-blue 误判为 baby-blue
  function getSlideColorClass(el, colorOrder) {
    if (!el || !colorOrder || !colorOrder.length) return null;
    for (let i = 0; i < colorOrder.length; i++) {
      if (el.classList && el.classList.contains(colorOrder[i])) return colorOrder[i];
    }
    const cls = ' ' + (el.className || '') + ' ';
    for (let i = 0; i < colorOrder.length; i++) {
      const handle = colorOrder[i].replace(/^filter-/, '');
      if (!handle) continue;
      const escaped = handle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const re = new RegExp('(^|\\s|-)' + escaped + '(\\s|-|$)');
      if (re.test(cls)) return colorOrder[i];
    }
    return null;
  }

  // 读取 DOM 中第一张能匹配色板的 slide 所属颜色
  // 当图片比色板颜色多时，首图可能不属于任何色板颜色，需要往后找第一张能匹配的
  function getFirstSlideColor(colorOrder) {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return null;
    const swiperComponent = gallery.querySelector('swiper-component');
    if (!swiperComponent) return null;
    // 只查主 swiper wrapper 下的 slide，排除缩略图 swiper
    const mainWrapper = swiperComponent.querySelector('.swiper-wrapper');
    const slides = mainWrapper ? mainWrapper.querySelectorAll('.swiper-slide') : swiperComponent.querySelectorAll('.swiper-slide');
    if (!slides.length) return null;
    if (colorOrder && colorOrder.length) {
      for (let i = 0; i < slides.length; i++) {
        const colorClass = getSlideColorClass(slides[i], colorOrder);
        if (colorClass) return colorClass;
      }
    }
    const classes = (slides[0].className || '').split(/\s+/);
    for (let i = 0; i < classes.length; i++) {
      if (classes[i].indexOf('filter-') === 0 && classes[i].length > 7) return classes[i];
    }
    return null;
  }

  // 进详情页时按首图颜色自动选中色板（不管 URL 是否带 variant 参数）
  // 直接设置 checked 并触发 change 事件，让 Shopify 变体系统更新价格/库存/URL；
  // 不手动调用 navigateToActiveColor（initAllInstances 末尾会统一做静默导航）
  // 注意：change 事件不是 trusted 事件，主题的 updateURL 不会把 variant 写入 URL，
  // 所以 URL 会被替换成不带 variant 的干净 URL，避免列表页链接带的 variant 与首图颜色不符
  function autoSelectFirstImageColor(firstColor) {
    if (!firstColor) return false;

    const targetFilter = '.' + firstColor;
    const instances = document.querySelectorAll('[is="variant-media-grouped"]');
    for (let i = 0; i < instances.length; i++) {
      const inputs = instances[i].querySelectorAll('input[type="radio"]');
      for (let j = 0; j < inputs.length; j++) {
        if (inputs[j].getAttribute('data-filter') === targetFilter) {
          if (inputs[j].checked) return false;
          if (inputs[j].disabled || inputs[j].classList.contains('disabled')) return false;
          inputs[j].checked = true;
          inputs[j].dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
    }
    return false;
  }

  function restoreCorruptedGallery() {
    const galleries = document.querySelectorAll('media-gallery');
    galleries.forEach(function (gallery) {
      try {
        if (!gallery._variantImageGroupedSnapshot) return;
        const snap = gallery._variantImageGroupedSnapshot;
        const swiperComponent = gallery.querySelector('swiper-component');
        const mainWrapper = swiperComponent && swiperComponent.querySelector('.swiper-wrapper');
        const thumbsWrapper = gallery.querySelector('.swiper-controls__thumbnails-container .swiper-wrapper');
        if (!mainWrapper || !snap || !snap.slides || !snap.slides.length) return;

        const mainSwiper = swiperComponent && (swiperComponent.initSwiper);
        const thumbsContainer = gallery.querySelector('.swiper-controls__thumbnails-container .swiper');
        const thumbsSwiper = thumbsContainer && thumbsContainer.swiper;
        try { mainSwiper && mainSwiper.destroy && mainSwiper.destroy(true, true); } catch(e){}
        try { thumbsSwiper && thumbsSwiper.destroy && thumbsSwiper.destroy(true, true); } catch(e){}

        mainWrapper.innerHTML = '';
        snap.slides.forEach(function (n) { mainWrapper.appendChild(n.cloneNode(true)); });
        if (thumbsWrapper && snap.thumbs) {
          thumbsWrapper.innerHTML = '';
          snap.thumbs.forEach(function (n) { thumbsWrapper.appendChild(n.cloneNode(true)); });
        }

        gallery.querySelectorAll(
          '.swiper-slide[class*="filter-"].hidden, ' +
            '.swiper-controls__thumbnail[class*="filter-"].hidden, ' +
            '.media-gallery__grid-item[class*="filter-"].hidden, ' +
            '.product-media-container[class*="filter-"].hidden'
        ).forEach(function (n) { n.classList.remove('hidden'); });

        swiperComponent.initializeSwiper && swiperComponent.initializeSwiper();
        delete gallery._variantImageGroupedSnapshot;
      } catch (e) { /* silent */ }
    });
  }

  function getVariantIdFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const vid = params.get('variant');
    return vid ? Number(vid) : null;
  }

  function initAllInstances() {
    restoreCorruptedGallery();

    const colorOrder = getColorOrder();
    if (colorOrder.length) {
      const urlVariantId = getVariantIdFromUrl();
      
      if (urlVariantId) {
        reorderAllGalleries(colorOrder, null);
      } else {
        const firstColor = getFirstSlideColor(colorOrder);
        const prioritizeColor = firstColor ? firstColor : null;
        reorderAllGalleries(colorOrder, prioritizeColor);
        const triggered = firstColor ? autoSelectFirstImageColor(firstColor) : false;
        if (triggered) {
          _silentNav = true;
        }
      }
    }

    // 导航到当前选中色板对应的首图，Swiper可能还在初始化，需要延时重试
    // URL带variant参数时，需要等待Shopify主题先完成变体选择初始化
    var _navAttempts = 0;
    var _maxAttempts = getVariantIdFromUrl() ? 8 : 3;
    function doNavigate() {
      _navAttempts++;
      const instances = document.querySelectorAll('[is="variant-media-grouped"]');
      var anyNavigated = false;

      var checkedColor = findCheckedColor();
      
      if (checkedColor) {
        const targetFilter = '.' + checkedColor;
        for (let i = 0; i < instances.length; i++) {
          const instance = instances[i];
          try {
            if (instance.swiper || instance._slider) {
              const inputs = instance.querySelectorAll('input[type="radio"]');
              let targetInput = null;
              for (let j = 0; j < inputs.length; j++) {
                if (inputs[j].getAttribute('data-filter') === targetFilter) {
                  targetInput = inputs[j];
                  break;
                }
              }
              if (targetInput) {
                navigateToActiveColor(instance, targetInput, false);
                anyNavigated = true;
                break;
              }
            }
          } catch (e) { /* silent */ }
        }
      } else {
        instances.forEach(function (instance) {
          try {
            if (!instance._input) return;
            if (instance._input.type === 'radio' && !instance._input.checked) return;
            if (instance.swiper || instance._slider) {
              navigateToActiveColor(instance, instance._input, false);
              anyNavigated = true;
            }
          } catch (e) { /* silent */ }
        });
      }
      
      if (!anyNavigated && _navAttempts < _maxAttempts) {
        var delay;
        if (getVariantIdFromUrl()) {
          delay = _navAttempts < 3 ? 150 : (_navAttempts < 6 ? 300 : 500);
        } else {
          delay = _navAttempts === 1 ? 200 : 600;
        }
        setTimeout(doNavigate, delay);
      }
    }
    
    if (getVariantIdFromUrl()) {
      _silentNav = true;
      setTimeout(doNavigate, 100);
    } else {
      doNavigate();
    }

    // 如果触发了 change，fetch 完成后 variantChange 事件会清除静默标志
    if (_silentNav) {
      if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        var unsub = subscribe(PUB_SUB_EVENTS.variantChange, function () {
          _silentNav = false;
          if (unsub) unsub();
        });
      }
      // 兜底：3 秒后强制清除，防止 subscribe 未注册或 fetch 超时
      setTimeout(function () { _silentNav = false; }, 3000);
    }
  }

  // 覆盖 media-gallery 的 setActiveMedia：
  //   1. 静默期（用户刚点击颜色/DOM替换恢复中）：跳过外部setActiveMedia调用，由guard timer恢复
  //   2. 所有setActiveMedia强制smooth=false（瞬切），不允许滑动动画
  function patchMediaGalleryProto(proto) {
    if (!proto || proto.__carbonGalleryPatched) return;
    proto.__carbonGalleryPatched = true;
    var origSetActiveMedia = proto.setActiveMedia;
    if (typeof origSetActiveMedia !== 'function') return;
    proto.setActiveMedia = function (mediaId, smooth) {
      if (_silentNav) return;
      return origSetActiveMedia.call(this, mediaId, false);
    };
  }

  // 给已存在的media-gallery实例打补丁
  function patchExistingMediaGalleries() {
    var galleries = document.querySelectorAll('media-gallery');
    for (var i = 0; i < galleries.length; i++) {
      var g = galleries[i];
      if (g.setActiveMedia && !g.setActiveMedia.__carbonInstancePatched) {
        (function(gallery) {
          var orig = gallery.setActiveMedia.bind(gallery);
          gallery.setActiveMedia = function(mediaId, smooth) {
            if (_silentNav) return;
            return orig(mediaId, false);
          };
          gallery.setActiveMedia.__carbonInstancePatched = true;
        })(g);
      }
    }
  }

  // ★ 关键修复：拦截 customElements.define，在 ctor 原型上先打补丁，再调用 define
  //   这样浏览器同步升级元素触发 connectedCallback 时，_applyFilterFromInput 等已经被覆盖，
  //   不会执行原始的 _rebuildGalleryWithFilters，从根源避免首屏过滤。
  const _origDefine = customElements.define.bind(customElements);
  customElements.define = function (name, ctor, options) {
    if (name === 'variant-media-grouped' && ctor && ctor.prototype) {
      patchPrototype(ctor.prototype);
    }
    if (name === 'media-gallery' && ctor && ctor.prototype) {
      patchMediaGalleryProto(ctor.prototype);
    }
    return _origDefine.call(this, name, ctor, options);
  };

  // === 动态标题功能 ===
  // 主标题：品牌 + 类别（如 "Dideyttawl Flower Girl Dress"），固定不变
  // 副标题：颜色 + 商品标题（去掉品牌名），颜色联动
  // 示例：选中Baby Blue → "Baby Blue Flower Girl Dresses White Puffy Tulle Princess Ball Gown"
  function initDynamicSubtitle() {
    var productData = window.__carbonProductData;
    var vendor = productData && productData.vendor ? productData.vendor.trim() : '';
    var productType = productData && productData.type ? productData.type.trim() : '';
    var fullTitle = productData && productData.title ? productData.title.trim() : '';
    if (!fullTitle) return;

    // 从完整标题中提取产品描述部分（只去掉品牌名）
    // 完整标题示例："Dideyttawl Flower Girl Dresses White Puffy Tulle Princess Ball Gown"
    // 提取结果："Flower Girl Dresses White Puffy Tulle Princess Ball Gown"
    function extractProductName() {
      var name = fullTitle;
      if (vendor) {
        var vendorRegex = new RegExp('^' + escapeRegex(vendor) + '\\s*', 'i');
        name = name.replace(vendorRegex, '');
      }
      return name.trim();
    }

    function escapeRegex(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    var productName = extractProductName();
    // 主标题文本：品牌 + 类别
    var mainTitleText = (vendor ? vendor + ' ' : '') + (productType || '');

    // .view-product-title 是 display:none，实际可见标题是 <h1> 或 .text-block
    var titleEl = document.querySelector('.product-details h1');
    if (!titleEl) {
      titleEl = document.querySelector('.product-details .text-block');
    }
    if (!titleEl) {
      titleEl = document.querySelector('h1');
    }
    if (!titleEl) return;

    // 获取标题内的链接元素（如果有）
    var titleLink = titleEl.querySelector('a');
    if (titleLink) {
      titleLink.textContent = mainTitleText;
    } else {
      titleEl.textContent = mainTitleText;
    }

    // 创建副标题元素（使用 h2 保留 heading 权重，利于 SEO）
    var subtitleEl = document.createElement('h2');
    subtitleEl.className = 'product-subtitle';
    // 内联样式覆盖主题 h2 默认样式，保持原 div 副标题的视觉效果
    subtitleEl.style.cssText = [
      'font-size: 1.5rem',
      'font-weight: normal',
      'margin: 0.5rem 0 0 0',
      'line-height: 1.4',
      'letter-spacing: normal',
      'text-transform: none',
      'color: var(--color-foreground)'
    ].join('; ');
    subtitleEl.dataset.productName = productName;
    titleEl.parentElement.appendChild(subtitleEl);

    // 标题处理完成，恢复显示（消除服务端渲染到JS替换之间的闪烁）
    titleEl.style.visibility = 'visible';

    function getSelectedColorName() {
      var checkedInputs = document.querySelectorAll('input[type="radio"][name^="Color"]:checked');
      for (var i = 0; i < checkedInputs.length; i++) {
        if (checkedInputs[i].value && !checkedInputs[i].closest('#sticky-atc, .sticky-add-to-cart')) {
          return checkedInputs[i].value.trim();
        }
      }
      if (checkedInputs.length > 0 && checkedInputs[0].value) {
        return checkedInputs[0].value.trim();
      }
      var allColorInputs = document.querySelectorAll('input[type="radio"][name^="Color"]:not([disabled])');
      for (var j = 0; j < allColorInputs.length; j++) {
        var input = allColorInputs[j];
        var parent = input.closest('.variant-pill, .swatch-element, label, [class*="swatch"], [class*="color"]');
        if (parent && (parent.classList.contains('active') || parent.classList.contains('selected') || parent.classList.contains('checked'))) {
          return input.value.trim();
        }
      }
      return null;
    }

    function updateSubtitle() {
      var colorName = getSelectedColorName();
      var pName = subtitleEl.dataset.productName || productName;
      if (colorName) {
        subtitleEl.innerHTML = '<span style="font-weight:500;">' + escapeHtml(colorName) + '</span> ' + escapeHtml(pName);
      } else {
        subtitleEl.textContent = pName;
      }
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(str));
      return div.innerHTML;
    }

    updateSubtitle();

    // 防抖：合并多次触发
    var _subtitleTimer = null;
    function scheduleSubtitleUpdate(delay) {
      if (_subtitleTimer) clearTimeout(_subtitleTimer);
      _subtitleTimer = setTimeout(function () {
        _subtitleTimer = null;
        updateSubtitle();
      }, delay || 50);
    }

    // 减少轮询重试：2次即可（首屏+主题异步渲染后）
    [500, 1500].forEach(function(ms) {
      setTimeout(updateSubtitle, ms);
    });

    // 在产品详情容器上委托事件，而非整个 document
    var detailContainer = titleEl.closest('.product-details, product-info, .product__info-container, main-product');
    var eventHost = detailContainer || document;

    eventHost.addEventListener('change', function (e) {
      var target = e.target;
      if (target && target.type === 'radio' && target.name && target.name.indexOf('Color') === 0) {
        scheduleSubtitleUpdate(50);
      }
    }, true);

    eventHost.addEventListener('click', function (e) {
      var target = e.target;
      if (target && target.closest) {
        var colorSwatch = target.closest('[class*="swatch"], [class*="color"], .variant-pill');
        if (colorSwatch) {
          scheduleSubtitleUpdate(100);
        }
      }
    }, true);

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        scheduleSubtitleUpdate(80);
      });
    }
  }

  function tryPatchExisting() {
    let Ctor;
    try { Ctor = customElements.get('variant-media-grouped'); } catch (e) { Ctor = null; }
    if (Ctor && Ctor.prototype) patchPrototype(Ctor.prototype);

    try { Ctor = customElements.get('media-gallery'); } catch (e) { Ctor = null; }
    if (Ctor && Ctor.prototype) patchMediaGalleryProto(Ctor.prototype);

    // 给已存在的media-gallery实例打补丁
    patchExistingMediaGalleries();
    // DOM加载后再打一次补丁（确保swiper初始化后的实例也被覆盖）
    setTimeout(patchExistingMediaGalleries, 500);
    setTimeout(patchExistingMediaGalleries, 1500);
    setTimeout(patchExistingMediaGalleries, 3000);

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      initAllInstances();
      try { initDynamicSubtitle(); } catch(e) { revealTitle(); }
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        initAllInstances();
        try { initDynamicSubtitle(); } catch(e) { revealTitle(); }
      });
    }
  }

  // 兜底：确保标题始终可见（即使 initDynamicSubtitle 出错或未执行）
  function revealTitle() {
    var h1 = document.querySelector('.product-details h1') || document.querySelector('h1');
    if (h1) h1.style.visibility = 'visible';
  }
  setTimeout(revealTitle, 2000);

  tryPatchExisting();
})();
